<template>
  <div>
    <nnav></nnav>
    <div class="bgimg" :style="{minHeight:MHeight}">
      <div class="userlist">
        <div class="list_head">
          <!-- 搜索 -->
          <div class="topTitle" style="margin-left: 40px;padding: 8px 0 13px;">
            <img
              style="margin-right: 8px;"
              src="../../../assets/images/dh111.png"
              alt=""
            />
            <span style="font-size: 14px;color: #2C2F37;">模拟测试</span
            ><span style="color: #868E99;font-size: 14px;"
              >&nbsp;>&nbsp;测试下载</span
            >
          </div>
      
          <div class="contnet" :style="{ minHeight: MHeight }">
            <div class="download_box">
              <!-- 模拟交易 -->
              <div class="title">
                <span class="shu"></span>
                <h2>模拟交易端下载</h2>
              </div>
              <div class="download" >
                <div class="download_img">
                  <img src="../../../assets/images/xaizai.png" alt="" />
                </div>
                <div class="download_right">
                  <p>杰宜斯模拟客户端2022 V{{res.version}}</p>
                  <!-- <a href="https://sim.jees.com.cn/TradeCtpClientAutoUpdate_mn/TradeCtpClient_mn.msi" style="display: block;" class="download_btn">立即下载</a> -->
                  <a href="https://sim.jees.com.cn/JeesSTCAutoUpdate_mn/JeesSTCSetup_mn.exe" style="display: block;" class="download_btn">立即下载</a>
                </div>
              </div>
              <!-- 量化 -->
              <div class="title">
                <span class="shu"></span>
                <h2>量化测试下载</h2>
              </div>
              <div class="download" style="padding:0;border: 0;">
                <!-- <h3 style="display: flex;align-items: center;"><img style="width: 16px;height: 16px;margin-right: 13px;" src="../../../assets/images/Windows.png" alt=""><span> Windows</span><span style="margin: 0 16px;font-size: 20px;">/</span>
                <img style="width: 19px;height: 22px;margin-right: 13px;" src="../../../assets/images/Linux.png" alt=""> <span>Linux</span></h3>
                <a
                  :href="res?this.$store.state.api + '/sim_api/getfile':''"
                  :download = "res?res.downLoad.name:''"
                  style="
                    font-size: 16px;
                    color:  #5b85ff;
                    display: block;
                    margin-bottom: 15px;
                  "
                 
                  >{{res?res.downLoad.name:''}}</a
                > -->
                <div class="table_box">
                    <div class="caption" >
                        <img src="../../../assets/images/Windows.png" alt="">
                        <span>Windows</span>
                    </div>
                    <el-table
                        size="small"
                        :data="tableRes.Windows"
                        style="width: 100%">
                        <el-table-column
                         width="60"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            label="安装包"
                            
                            >
                        </el-table-column>
                        <el-table-column
                            prop="version"
                            label="对应CTP版本号"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="fileSizeStr"
                            label="大小">
                        </el-table-column>
                        <el-table-column
                            prop="addTime"
                            label="更新时间">
                        </el-table-column>
                        <el-table-column
                        width="60"
                            label="下载">
                            <template slot-scope="scope">
                                
                                <a target="_blank" :href="'/api' +'/sim_api_two/getfile?id='+ scope.row.id" class="el-icon-download decoration"></a>
                            </template>
                        </el-table-column>
                        <el-table-column
                         width="60"
                            >
                        </el-table-column>
                    </el-table>
                </div>
                <h4>使用Windows接口需注意：</h4>
                <h5>
                 
                
                    1.windows接口的编译环境为vc10.0 <br/>
                    2.python目前只提供windows版本，编译环境为python3.7，C++转换python工具使用的是swigwin4.0<br/>
                    3.VNPY接入请先查阅：<a target="_blank" href="/api/download/Windows.pdf">VNPY使用杰宜斯接口手册(Windows).pdf</a>
                </h5>


                <div class="table_box">
                    <div class="caption" >
                        <img src="../../../assets/images/Linux.png" alt="">
                        <span>Linux</span>
                    </div>
                    <el-table
                        size="small"
                        :data="tableRes.Linux"
                        style="width: 100%">
                        <el-table-column
                         width="60"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            label="安装包"
                            
                            >
                        </el-table-column>
                        <el-table-column
                            prop="version"
                            label="对应CTP版本号"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="fileSizeStr"
                            label="大小">
                        </el-table-column>
                        <el-table-column
                            prop="addTime"
                            label="更新时间">
                        </el-table-column>
                        <el-table-column
                           width="60"
                            label="下载">
                            <template slot-scope="scope">
                                <a target="_blank" :href="'/api' + '/sim_api_two/getfile?id='+ scope.row.id" class="el-icon-download decoration"></a>
                            </template>
                        </el-table-column>
                        <el-table-column
                         width="60"
                            >
                        </el-table-column>
                    </el-table>
                </div>
                <h4>使用Linux接口需注意：</h4>
                <h5>
                    
                    1. linux接口的编译环境为gcc4.8.4<br/>
                    2. python接口，编译环境为python3，C++转换python工具使用的是swig4.0<br/>
                    3.VNPY接入请先查阅：<a target="_blank" href="/api/download/Linux.pdf">VNPY使用杰宜斯接口手册(Linux).pdf</a>
                </h5>


                <div class="table_box">
                    <div class="caption" >
                        <img src="../../../assets/images/wendang.png" alt="">
                        <span>JEES_API_介绍文档</span>
                    </div>
                    <el-table
                        size="small"
                        :data="file"
                        style="width: 100%">
                        <el-table-column
                         width="60"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            label="安装包"
                            
                            >
                        </el-table-column>
                        <el-table-column
                            prop="version"
                            label="版本号"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="fileSizeStr"
                            label="大小">
                        </el-table-column>
                        <el-table-column
                            prop="addTime"
                            label="更新时间">
                        </el-table-column>
                        <el-table-column
                           width="60"
                            label="下载">
                            <template slot-scope="scope">
                                <a target="_blank" href="/api/download/6.3.15_JEES_API.pdf" class="el-icon-download decoration"></a>
                            </template>
                        </el-table-column>
                        <el-table-column
                         width="60"
                            >
                        </el-table-column>
                    </el-table>
                </div>
               


                
                <h3 style="margin-top: 35px;">使用说明</h3>
                <h6>
                    1. 杰宜斯接口暂不强制认证，投顾认证流程可以保留，AppID和授权码可以暂时填空或保持原来设置<br/>
                    2. 接入前请确认接口对应的ctp版本，行情接口请自行连接期货公司ctp行情柜台前置<br/>
                    3. 模拟测试账户需要单独提交测试申请，如果需要连接实盘，请跟对应的系统管理方联系<br/>
                    4. 接口报单时，OrderRef字段必须赋值，且要求每笔报单递增<br/>
                    5. 接口撤单时，推荐以FrontID+SeessionID+OrderRef 来报送撤单指令<br/>
                    6. linux接口的编译环境为gcc4.8.4，对应操作系统为Ubuntu14.04<br/>
                    7. python版本支持python3.X，C++转换python工具使用的是swig
                </h6>




<!--            
                <p v-html ="res?res.downLoad.content:''">
                  1.杰宜斯接口暂不强制认证，投顾认证流程可以保留，AppID和授权码可以暂时填空或保持原来设置<br />
                  2.杰宜斯接口只提供交易接口（对应ctp版本6.3.15），行情接口请自行连接期货公司ctp行情柜台前置<br />
                  3.模拟测试账户需要单独提交测试申请，如果需要连接实盘，请跟对应的系统管理方联系<br />
                  4.linux接口的编译环境为gcc4.8.4 <br />
                  5.windows接口的编译环境为vc10.0<br />
                  6.python目前只提供windows版本，编译环境为python3.7，C++转换python工具使用的是swigwin4.0<br />
                  7.接口报单时，OrderRef字段必须赋值，且要求每笔报单递增<br />
                  8.接口撤单时，推荐以FrontID+SeessionID+OrderRef 来报送撤单指令
                </p> -->
              </div>
            </div>
          </div>
     
          
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import nnav from '../../../components/nav/index';
import './style.css';
export default {
  name: 'download',
  components: { nnav },
  data() {
    return {
        MHeight: document.documentElement.clientHeight - 160 + 'px',
      res:'',
      tableRes:{},
      file:[
          {
            name:'介绍文档.pdf',
            version:"1.0",
            fileSizeStr:'1.0M',
            addTime:"12/12/24"

          }
          
      ]
    };
  },
  mounted() {
    this.$axios.post(
      '/sim_api_two/download'
    ).then(res=>{
      console.log(res,666)
      this.tokenInvalid(res)

      if(res.data.code == 200){
        let obj = {}
        let Windows = []
        let Linux = []
        res.data.datas.forEach(item=>{
            item.addTime=item.addTime.substr(0,10)
            if(item.platform == "Windows"){
                Windows.push(item)   
            }
            if(item.platform == "Linux"){
                Linux.push(item)
            }
        })
        obj.Windows = Windows
        obj.Linux = Linux
        this.tableRes = obj
      }
    })


    this.$axios.post(
      '/sim_api/download'
    ).then(res=>{
    //   console.log(res)
    //   this.tokenInvalid(res)
      if(res.data.code == 200){
        this.res = res.data.data
      }
    })



    



    

    
  },
  methods: {
        dowmloadBtn(id){
            this.$axios.post(
        '/sim_api_two/getfile',
        {id:id}
        ).then(res=>{
            console.log(res)
        })
      }
  },
};
</script>



// WEBPACK FOOTER //
// src/view/user/download/index.vue